export default __webpack_public_path__ + "static/media/unpin_green.9456a73d.svg";